import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { TerraDividerModule, TerraIconModule } from '@ninety/terra';
import { ButtonComponent } from '@ninety/ui/core';

import {
  MeetingSidenavToolsMenuComponent,
  MeetingViewTool,
} from '../meeting-sidenav-tools-menu/meeting-sidenav-tools-menu.component';

@Component({
  standalone: true,
  selector: 'ninety-meeting-sidenav-actions',
  templateUrl: './meeting-sidenav-actions.component.html',
  styleUrls: ['./meeting-sidenav-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, TerraIconModule, TerraDividerModule, MeetingSidenavToolsMenuComponent],
})
export class MeetingSidenavActionsComponent {
  readonly showNotes = input(false);
  readonly disabled = input(false);

  readonly tools = input<MeetingViewTool[]>([]);
  readonly meetingId = input.required<string>();

  readonly isPresenter = input(false);
  readonly canFinish = input(true);

  /** `Day 1` / `Day 2` suffix for annual meetings; empty for every other type. */
  readonly dayLabel = input('');

  readonly tangentClicked = output<void>();

  /** Re-emitted from the tools menu: the chosen tool's label. */
  readonly toolSelected = output<string>();
  readonly notesToggled = output<void>();
  readonly finishClicked = output<void>();
}
